export { Swatch, type SwatchProps } from './swatch';
